// import * as Routes from '../constants/routes';
// import { trackingEvent } from '../helpers/tracking';

// import Intro from '../calculators/pay-yourself-first/containers/intro';
import SavingsGrowth from '../calculators/investing-taxes/containers/savings-growth';
import StayInvested from '../calculators/investing-taxes/containers/stay-invested';
import TimeToRecover from '../calculators/investing-taxes/containers/time-to-recover';
import GICLaddering from '../calculators/investing-taxes/containers/gic-laddering';
import TFSATaxable from '../calculators/investing-taxes/containers/tfsa-taxable';
import InvestmentFees from '../calculators/investing-taxes/containers/investment-fees';
import InvestmentIncome from "../calculators/investing-taxes/containers/investment-income";

export const name = 'Investing & Taxes';

export const inSecondaryMenu = true;

export const routes = [
    // {
    //     path: Routes.HOME,
    //     component: Intro,
    //     pagination: false,
    //     progressBar: false
    // },
    {
        path: '/savings-growth',
        name: 'Savings Growth',
        component: SavingsGrowth,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/stay-invested',
        name: 'Stay Invested',
        component: StayInvested,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/time-to-recover',
        name: 'Time To Recover',
        component: TimeToRecover,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/gic-laddering',
        name: 'GIC Laddering',
        component: GICLaddering,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/tfsa-taxable',
        name: 'TFSA vs Taxable Investment',
        component: TFSATaxable,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/investment-fees',
        name: 'Investment Fees',
        component: InvestmentFees,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/investment-income',
        name: 'Taxes and Investment Income Calculator',
        component: InvestmentIncome,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    }
];
